const styles = {
  root: {
    display: ' flex',
    height: '100%'

  },
  githubStatsContainer: {
    flex: 1,
    marginTop: '8%'
  },
  headerText: {
    textAlign: 'center'
  },
  underlineContainer: {
    display: 'inline-flex',
    marginTop: '4%',
    textAlign: 'center'
  },
  text: {
    alignSelf: 'center',
    paddingRight: 20,
    marginLeft: '1%',
    width: 200,
    textAlign: 'center'

  },
  numberText: {
    textAlign: 'center'
  }
}

export default styles
